
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'staffefficiency'
    })
  } // computed
}; // export default
